export const PRODUCT_NAVIGATION_EVENT = "product-navigation";
export const productDetailPath = (entityId: number) => `/product-management/products/${entityId}`;
export function productEntityId(pathname: string): number | null {
  const match = /^\/product-management\/products\/([1-9]\d*)\/?$/.exec(pathname);
  const id = match ? Number(match[1]) : NaN;
  return Number.isSafeInteger(id) && id <= 2147483647 ? id : null;
}
export function appScrollContainer(): HTMLElement | null {
  return document.querySelector<HTMLElement>("[data-app-scroll]");
}
export function openProductDetail(entityId: number, searchUrl: string) {
  if (productEntityId(productDetailPath(entityId)) === null) return;
  const scrollTop = appScrollContainer()?.scrollTop ?? window.scrollY;
  history.replaceState({ ...history.state, searchScroll: scrollTop }, "", searchUrl);
  history.pushState({ returnToSearch: searchUrl, fromProductSearch: true }, "", productDetailPath(entityId));
  window.dispatchEvent(new Event(PRODUCT_NAVIGATION_EVENT));
  appScrollContainer()?.scrollTo({ top: 0 });
}
export function backToProductSearch() {
  if (history.state?.fromProductSearch) { history.back(); return; }
  history.pushState(null, "", "/product-management/search?page=1&pageSize=20");
  window.dispatchEvent(new Event(PRODUCT_NAVIGATION_EVENT));
}

export function openProductSearch(searchTerm = "", category?: string) {
  const params = new URLSearchParams({ page: "1", pageSize: "20" });
  if (searchTerm.trim()) params.set("q", searchTerm.trim());
  if (category) params.set("category", category);
  history.pushState(null, "", `/product-management/search?${params}`);
  window.dispatchEvent(new Event(PRODUCT_NAVIGATION_EVENT));
  appScrollContainer()?.scrollTo({ top: 0 });
}
